<template>
  <el-card>
    <page-main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
      >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @openEditFormDialog="openEditFormDialog"
        :orgRow="orgRow"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <el-dialog
      v-if="editFormDialogOptions.visible"
      show-close
      visible
      width="600px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
      v-el-dialog-drag
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :categoryCode="editFormDialogOptions.code"
        :orgRow="orgRow"
        :isadd="editFormDialogOptions.isadd"
        @reload="reload"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()">{{
          this.$l('INDEX.btn_cancel') || 取消
        }}</el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!editFormDialogOptions.disabled"
          @click="$refs.editForm.save()"
          >{{ this.$l('INDEX.btn_save') || 保存 }}</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditForm from '../edit-form'
export default {
  components: {
    PageHeader,
    PageMain,
    EditForm,
  },
  mixins: [BaseTable],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
        code: '',
      },
      orgRow: {},
      //parentDep: {},
    }
  },
  mounted() {
    this.$eventBus.$on('selectList', (row) => {
      this.orgRow = row
      this.$refs.header.orgChange(row)
    })
  },
  methods: {
    getData(form) {
      //console.log(form)
      this.parentDep = {}
      this.loading = true
      this.$api
        .masCategoryListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, code = '' }) {
      const types = {
        edit: this.$l('form_label_category_edit') || '编辑样品分类信息',
        add: this.$l('form_label_category_add') || '添加样品分类信息',
        detail: this.$l('form_label_category_detail') || '样品分类信息详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        isadd: type === 'add',
        title: types[type],
        code: code,
        disabled: type === 'detail',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
      this.$refs.main.onCurrentCategoryTreeChange()
    },
    // depRowChange(row) {
    //   this.parentDep = row
    // },
  },
}
</script>
